export default "__VITE_ASSET__DrFi5Fn0__"